import $ from 'jquery';
import 'bootstrap';
import './utils/sliders';
import './utils/callback';
import { initConsultationHcaptcha } from './utils/consultation-hcaptcha';
import Inputmask from "inputmask";
import { Modal } from 'bootstrap';

// эта настройка нужна для корректной работы $ вне этого приложения
window.$ = $;
window.jQuery = $;
window.Modal = Modal;

require('@fancyapps/fancybox');

$(function () {
    const mask = new Inputmask('+7 (999) 999-99-99');
    mask.mask(document.querySelectorAll('.maskedinput-phone'));
    initConsultationHcaptcha();

    // fancybox
    $('[data-fancybox="gallery"]').fancybox();

    let url = window.location.pathname;
    url = url.split('/');
    url = '/' + url[1];
    $('.nav-item a[href="' + url + '"]').addClass('active');

    $(window).scroll(function () {
        if ($(this).scrollTop() > 200) {
            $('.scrollup').removeClass('d-none');
        } else {
            $('.scrollup').addClass('d-none');
        }
    });

    $('.scrollup').click(function () {
        $("html, body").animate({
            scrollTop: 0
        }, 600);
        return false;
    });

    // let navbarToggler = document.querySelector('.navbar-toggler')
    // let headerNavbar = document.querySelector('.header__navbar')
    //
    // navbarToggler.addEventListener('click', function () {
    //     if (navbarToggler.getAttribute('aria-expanded') === 'true') {
    //         headerNavbar.classList.add('header__navbar_open')
    //     } else {
    //         headerNavbar.classList.remove('header__navbar_open')
    //     }
    // })
    //
    if (window.innerWidth > 991) {
        $('.header__navbar-nav .dropdown').mouseover(function() {
            $(this).find('a[data-bs-toggle="dropdown"]').addClass('hover');
            $(this).find('.dropdown-menu').stop(true, true).delay(0).fadeIn(125);
        }).mouseout(function() {
            $(this).find('a[data-bs-toggle="dropdown"]').removeClass('hover');
            $(this).find('.dropdown-menu').stop(true, true).delay(0).fadeOut(50);
        })
    }


    $(document).on('click', 'a[data-scroll^="#"]', function (event) {
        event.preventDefault();

        $('html, body').animate({
            scrollTop: ($($.attr(this, 'data-scroll')).offset().top - 100)
        }, 700);
    });

    if (document.querySelector('input[type=file]')) {
        let fileInputs = document.querySelectorAll('input[type=file]');
        fileInputs.forEach(function(input) {
            input.addEventListener('change', function() {

                let profilePicValue = input.value;
                let fileNameStart = profilePicValue.lastIndexOf('\\');
                profilePicValue = profilePicValue.substr(fileNameStart + 1);
                let profilePicLabelText = input.nextElementSibling;

                if (profilePicValue !== '') {
                    profilePicLabelText.innerHTML = 'Выбрать другой';
                    profilePicLabelText.classList.add('active');
                } else {
                    profilePicLabelText.innerHTML = 'Прикрепить файл';
                    profilePicLabelText.classList.remove('active');
                }
            });
        });
    }

    if (document.querySelector(".to-top")) {
        let toTop = document.querySelector(".to-top");

        window.onscroll = function() {
            scrollFunction()
        };

        function scrollFunction() {
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                toTop.classList.add('show');
            } else {
                toTop.classList.remove('show');
            }
        }

        function topFunction() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }

        toTop.addEventListener('click', function() {
            topFunction()
        })
    }
});


$(document).ready(function() {
    const animationDuration = 1;

    // Выбираем все элементы с классом 'svg-anim'
    const svgAnims = $('.svg-anim');

    // Функция для проверки элементов 'svg-anim' и выполнения анимации
    function checkSvgAnims() {
        const scrollTop = $(window).scrollTop();
        const windowHeight = $(window).height();

        // Перебираем каждый элемент 'svg-anim'
        svgAnims.each(function(index, svgAnim) {
            const svgAnimTop = $(svgAnim).offset().top;

            // Проверяем, находится ли элемент в зоне видимости экрана
            if ((svgAnimTop >= scrollTop) && (svgAnimTop < (scrollTop + windowHeight))) {
                // Ваш код для анимации элемента 'svg-anim'
                const fillPaths = $(svgAnim).children();
                const filledPathsCount = $(svgAnim).data('filled-paths-count');

                fillPaths.each(function(pathIndex, path) {
                    const percentage = (pathIndex < filledPathsCount) ? 100 : 0;
                    const delay = animationDuration / filledPathsCount;

                    if (pathIndex < filledPathsCount) {
                        path.classList = "fill-animation";
                        $(path).css('animation-name', 'fillPath');
                        $(path).css('animation-duration', animationDuration + 's');
                        $(path).css('animation-delay', (pathIndex * delay) + 's');
                        $(path).css('--fill-percentage', percentage);
                    }
                });
            }
        });
    }

    // Вызываем функцию при загрузке страницы
    checkSvgAnims();

    // Вызываем функцию при прокрутке страницы
    $(window).scroll(checkSvgAnims);
});





//Добавляем классы объектам в зоне видимости (скролл)

function onEntry(entry) {
  entry.forEach(change => {
    if (change.isIntersecting) {
      change.target.classList.add('element-show');
    }
  });
}

let options = {
  threshold: [0.3] };
let observer = new IntersectionObserver(onEntry, options);
let elements = document.querySelectorAll('.element-animation');
let elementsImage = document.querySelectorAll('.element-animation-wrapper');

for (let elm of elements) {
  observer.observe(elm);
}

for (let elm of elementsImage) {
  observer.observe(elm);
}


//Эффект наложения блока при скролле
$(function(){
    let id = '#app-main-header,#app-services,#app-specialists,#app-advantages,#app-reviews,#app-about,#app-consultation';
    $('head').append('<style>body {overflow-x: hidden;}#allrecords {overflow: visible !important;}#t-header,#t-footer {position: relative;z-index: 2;} .t-rec {position: relative;z-index: 1;overflow-x: hidden;}'+id+' { position: -webkit-sticky; position: sticky; top: 0; z-index: 0;}</style>');
    $(window).on('load resize', function(){
        if ($(window).width() > 992) { // Проверяем разрешение экрана
            $(id).each(function(){
                let topPosition = $(window).height() - $(this).height();
                if (topPosition < 0) {
                    $(this).css('top',topPosition)
                } else {
                    $(this).css('top',0)
                }
            });
        } else {
            $(id).css('top', 'auto'); // Отключаем стили для блоков при меньшем разрешении
        }
    });
});

//Производим клик на указанный id
const hash = window.location.hash;
if (hash === "#pills-reviews-clinic-tab") {
    document.getElementById("pills-reviews-clinic-tab").click();
}
if (hash === "#pills-reviews-doctors-tab") {
    document.getElementById("pills-reviews-doctors-tab").click();
}
